// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3doYW","top":"styles_top__2U9aw","left":"styles_left__1G4Fz","description":"styles_description__24BDa"};